import { CONNECT_TO_SOCKET, AUTHORIZE_WITH_SOCKET, DISCONNECT_FROM_SOCKET, SEND_TO_SOCKET } from './consts';
export const isConnectToSocketActon = (action) => action.type === CONNECT_TO_SOCKET;
export const isAuthorizeWithSocketAction = (action) => action.type === AUTHORIZE_WITH_SOCKET;
export const isDisconnectFromSocketAction = (action) => action.type === DISCONNECT_FROM_SOCKET;
export const isSendToSocketAction = (action) => action.type === SEND_TO_SOCKET;
//# sourceMappingURL=typeGuards.js.map